import { useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { useNavigate } from 'react-router-dom';
import { useSearchCarrierLazyQuery } from '../../utils/__generated__/graphql';

const CarrierSearchDropdown = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [search, { loading, data }] = useSearchCarrierLazyQuery({
    variables: { searchTerm },
  });

  const options =
    data?.carrier.map((result) => ({
      value: result.id,
      label: result.name,
    })) || [];

  const handleInputChange = (newValue: string) => {
    setSearchTerm(newValue);
    search({ variables: { searchTerm: newValue } });
  };

  const handleClick = (
    opt: SingleValue<{
      value: any;
      label: string;
    }>
  ) => {
    navigate(`edit/${opt?.value}`);
  };

  return (
    <Select
      options={options}
      isLoading={loading}
      isClearable
      isSearchable
      onInputChange={handleInputChange}
      onChange={handleClick}
      placeholder="Search restaurants..."
    />
  );
};

export default CarrierSearchDropdown;
